import * as constants from './constants'

export const generateNames = (names, value) => names.reduce((names, name) => ((names[name] = value), names), {})

export default function reducer(state = {}, action) {
    const { type, names, error } = action

    switch (type) {
        case constants.PROCESS_STARTED:
            return {
                ...state,
                ...generateNames(names, true),
            }

        case constants.PROCESS_COMPLETED:
            return {
                ...state,
                ...generateNames(names),
            }

        case constants.PROCESS_FAILED:
            return {
                ...state,
                ...generateNames(names, error),
            }

        case constants.CLEAR_PENDING:
            return {
                ...state,
                ...generateNames(names.filter(name => state[name] !== true)),
            }

        default:
            return state
    }
}
